import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from '../ModalGeneric'

import CalendarImg from 'static/images/graphic-calendar.jpg'

import { ReactComponent as IconCalendar } from 'static/svg/icon-calendar-graphics.svg'
import { ReactComponent as IconReservation } from 'static/svg/icon-reservation-graphics.svg'
import { ReactComponent as IconChatBubble } from 'static/svg/icon-chat-bubble-graphics.svg'
import { ReactComponent as IconRingPhone } from 'static/svg/icon-ring-phone-graphics.svg'
import { ReactComponent as IconHandshake } from 'static/svg/icon-handshake-graphics.svg'

import {
  Container,
  InformationList,
  InformationItem,
  Icon,
  Image,
} from './styles'

interface PatientsAverageScheduleModalProps {
  onClose: () => void
}

export function PatientsAverageScheduleModal({
  onClose,
}: PatientsAverageScheduleModalProps): JSX.Element {
  return (
    <ModalGeneric
      modalTitle='Dicas para melhorar sua média de consultas por paciente'
      hasButton
      btnText='ENTENDI'
      onCloseModal={onClose}
      btnOnClick={onClose}
    >
      <Container>
        <Image 
          src={CalendarImg}
          alt='Tabela de pacientes que mais faltaram e cancelaram'
        />

        <InformationList>

          <InformationItem>
            <Icon>
              <IconCalendar />
            </Icon>
            <Typography
              variant='content2'
            >
              {<>Ao final da consulta, <strong>estimule o paciente a agendar a próxima</strong> e continuar se comprometendo com o bem-estar dele.</>}
            </Typography>
          </InformationItem>

          <InformationItem>
            <Icon>
              <IconReservation />
            </Icon>
            <Typography
              variant='content2'
            >
              {<><strong>Ofereça a reserva de horário a pacientes</strong> que pretendem se consultar recorrentemente com você. Deste modo, eles garantem um horário semanal, e isso automaticamente eleva a frequência de consulta para o máximo de realizações possíveis em um mês.</>}
            </Typography>
          </InformationItem>

          <InformationItem>
            <Icon>
              <IconChatBubble />
            </Icon>
            <Typography
              variant='content2'
            >
              {<>Sobretudo na primeira consulta, <strong>esclareça que o benefício da psicoterapia se revela ao longo de algumas sessões</strong>, e que é importante o paciente se permitir ter a experiência completa, com o máximo de frequência possível, uma vez por semana.</>}
            </Typography>
          </InformationItem>

          <InformationItem>
            <Icon>
              <IconRingPhone />
            </Icon>
            <Typography
              variant='content2'
            >
              {<>Você tem à sua disposição o telefone e o e-mail de cada um dos seus pacientes. Caso sinta-se confortável, fique a vontade e <strong>entre em contato para checar se há algum imprevisto para realizar a sessão agendada.</strong></>}
            </Typography>
          </InformationItem>

          <InformationItem>
            <Icon>
              <IconHandshake />
            </Icon>
            <Typography
              variant='content2'
            >
              {<>Lembre-se da importância de <strong>firmar o seu contrato terapêutico já na 1ª sessão.</strong> Reforce sobre a importância da adesão, a recorrência ao tratamento é fundamental.</>}
            </Typography>
          </InformationItem>

        </InformationList>
      </Container>

    </ModalGeneric>
  )
}